export interface OwnerInvitationEntry {
  code: string;
  email: string;
}

export function readOwnerInvitation(hash: string): OwnerInvitationEntry | null {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  const code = params.get('invitation') ?? '';
  const email = params.get('email') ?? '';
  if (
    params.getAll('invitation').length !== 1 ||
    params.getAll('email').length !== 1 ||
    !/^[a-f0-9]{64}$/.test(code) ||
    email.length > 320 ||
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  )
    return null;
  return { code, email };
}
